import { getShiComBaseUrl } from "@lib/shiComBaseUrl";

/**
 * SHI.com path the cart's "Save as Quote" action redirects to. The final web quoting
 * destination is still being finalized, so this is centralized here (SPU-538) as the
 * single source of truth for both the mini-cart and the cart summary — repoint it in
 * one place when the destination ships.
 */
export const SAVE_AS_QUOTE_PATH = "/quote/save-as-quote";

/**
 * Resolves the "Save as Quote" redirect URL (SPU-538).
 *
 * Per the epic constraint this is a **redirect only** — the cart never creates, prompts
 * for, or stores quote data.
 */
export function getSaveAsQuoteUrl(): string {
  return `${getShiComBaseUrl()}${SAVE_AS_QUOTE_PATH}`;
}
